import React from "react";
import { useLanguage } from "../context/LanguageContext";

const Service = () => {
  const { lang } = useLanguage();

  const t = {
    sq: {
      title: "Shërbimet tona IT",
      sub: "Zgjidhje profesionale për pajisjet dhe biznesin tuaj",
      servicesTitle: "Shërbimet",
      ctaTitle: "Ke nevojë për një shërbim?",
      ctaSub: "Na kontakto dhe ne do të të ndihmojmë menjëherë.",
      contact: "Kontakto tani",

      services: [
        {
          title: "Shërbime IT për Biznese",
          icon: "🚀",
          desc: "Zgjidhje të avancuara IT: zhvillim platformash web, automatizim procesesh, marketing digjital dhe siguri rrjeti.",
        },
        {
          title: "Shërbime IT për Familje",
          icon: "🔧",
          desc: "Mbështetje teknike në shtëpi: instalim software, optimizim pajisjesh dhe zgjidhje për çdo problem teknologjik.",
        },
        {
          title: "Riparime Laptop & PC",
          icon: "💻",
          desc: "Diagnostikim dhe riparim hardware/software për laptop dhe desktop.",
        },
        {
          title: "Instalim Software & Mirëmbajtje",
          icon: "⚙️",
          desc: "Instalim sistemi operativ, programe profesionale dhe optimizim për performancë maksimale.",
        },
        {
          title: "Rikuperim të Dhënash",
          icon: "💾",
          desc: "Shpëtim i të dhënave të humbura nga pajisje të dëmtuara me metoda profesionale.",
        },
        {
          title: "Siguri & Antiviruse",
          icon: "🔒",
          desc: "Mbrojtje nga viruset, malware dhe konfigurim sigurie për pajisjet tuaja.",
        },
        {
          title: "Menaxhim Rrjetesh",
          icon: "🌐",
          desc: "Monitorim, konfigurim dhe mirëmbajtje e rrjeteve kompjuterike për performancë dhe siguri maksimale.",
        },
        {
          title: "Web & Marketing",
          icon: "💻📈",
          desc: "Krijim website, menaxhim social media dhe marketing digjital.",
        },
        {
          title: "Optimizim i Faqeve të Internetit",
          icon: "🚀",
          desc: "Përmirësim i shpejtësisë, performancës dhe SEO të faqeve të internetit për ngarkim më të shpejtë dhe renditje më të mirë.",
        },
      ],
    },

    en: {
      title: "Our IT Services",
      sub: "Professional solutions for your devices and business",
      servicesTitle: "Services",
      ctaTitle: "Need a service?",
      ctaSub: "Contact us and we will help you immediately.",
      contact: "Contact now",

      services: [
        {
          title: "IT Services for Businesses",
          icon: "🚀",
          desc: "Advanced IT solutions: web platforms, process automation, digital marketing and network security.",
        },
        {
          title: "IT Services for Home Users",
          icon: "🔧",
          desc: "Home technical support: software installation, device optimization and tech problem solving.",
        },
        {
          title: "Laptop & PC Repair",
          icon: "💻",
          desc: "Hardware/software diagnostics and repair for laptops and desktops.",
        },
        {
          title: "Software Installation & Maintenance",
          icon: "⚙️",
          desc: "OS installation, professional software setup and performance optimization.",
        },
        {
          title: "Data Recovery",
          icon: "💾",
          desc: "Recovery of lost data from damaged devices using professional methods.",
        },
        {
          title: "Security & Antivirus",
          icon: "🔒",
          desc: "Protection from viruses, malware and security configuration for your devices.",
        },
        {
          title: "Network Management",
          icon: "🌐",
          desc: "Monitoring, configuration and maintenance of computer networks for maximum performance and security.",
        },
        {
          title: "Web & Marketing",
          icon: "💻📈",
          desc: "Website creation, social media management and digital marketing.",
        },
        {
          title: "Website Optimization",
          icon: "🚀",
          desc: "Improving speed, performance and SEO for faster loading and better ranking.",
        },
      ],
    },
  };

  const text = t[lang] || t.sq;

return (
  <main className="!min-h-0 h-auto bg-slate-50 px-4 pt-8 pb-6 md:px-6 lg:pt-10 lg:pb-8">
    <div className="mx-auto w-full max-w-[1750px]">
      {/* HEADER */}
      <div className="mx-auto mb-10 max-w-3xl text-center">
        <span className="mb-3 block text-xs font-extrabold uppercase tracking-[0.18em] text-violet-600">
          MASTER SOL&amp;TECH
        </span>

        <h1 className="text-3xl font-black tracking-tight text-slate-950 md:text-5xl">
          {text.title}
        </h1>

        <p className="mt-4 text-base leading-7 text-slate-600 md:text-lg">
          {text.sub}
        </p>
      </div>

      {/* SERVICES GRID */}
      <section className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {text.services.map((service, index) => (
          <article
            key={index}
            className="
              group
              relative
              min-h-[225px]
              overflow-hidden
              rounded-[22px]
              border
              border-slate-200
              bg-white
              p-6
              shadow-[0_10px_30px_rgba(15,23,42,0.06)]
              transition-all
              duration-300
              hover:-translate-y-2
              hover:border-violet-200
              hover:shadow-[0_18px_45px_rgba(79,70,229,0.12)]
            "
          >
            <div className="absolute -right-10 -top-10 h-28 w-28 rounded-full bg-gradient-to-br from-violet-100 to-blue-100 opacity-70 blur-2xl transition duration-300 group-hover:scale-125" />

            <div className="relative z-10 mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-violet-100 to-blue-100 text-3xl shadow-inner transition duration-300 group-hover:scale-110 group-hover:rotate-6">
              {service.icon}
            </div>

            <h3 className="relative z-10 text-lg font-extrabold leading-snug text-slate-900">
              {service.title}
            </h3>

            <p className="relative z-10 mt-3 text-sm leading-6 text-slate-600">
              {service.desc}
            </p>

            <div className="absolute bottom-0 left-0 h-1 w-0 rounded-r-full bg-gradient-to-r from-violet-600 to-blue-500 transition-all duration-300 group-hover:w-full" />
          </article>
        ))}
      </section>

      {/* CTA */}
      <section
        className="
          relative
          mt-10
          overflow-hidden
          rounded-[28px]
          border
          border-violet-200
          bg-gradient-to-r
          from-violet-600
          via-indigo-600
          to-blue-600
          px-6
          py-8
          text-center
          text-white
          shadow-[0_24px_60px_rgba(79,70,229,0.25)]
          md:px-10
          md:py-10
        "
      >
        <div className="absolute -left-16 -top-16 h-48 w-48 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-20 -right-16 h-56 w-56 rounded-full bg-cyan-300/10 blur-3xl" />

        <div className="relative z-10 mx-auto max-w-3xl">
          <h2 className="text-2xl font-black md:text-4xl">
            {text.ctaTitle}
          </h2>

          <p className="mt-4 text-sm leading-7 text-white/80 md:text-base">
            {text.ctaSub}
          </p>

          <button
            type="button"
            onClick={() => {
              const phone = "355674909765";

              const message =
                lang === "sq"
                  ? `Përshëndetje,\n\nJam i interesuar për shërbimet tuaja.\nJu lutem më kontaktoni.\n\nFaleminderit!`
                  : `Hello,\n\nI am interested in your services.\nPlease contact me.\n\nThank you!`;

              window.open(
                `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
                "_blank"
              );
            }}
            className="
              mt-6
              inline-flex
              min-h-[48px]
              items-center
              justify-center
              gap-3
              rounded-xl
              bg-green-500
              px-7
              text-sm
              font-extrabold
              text-white
              shadow-[0_14px_30px_rgba(22,163,74,0.30)]
              transition
              hover:-translate-y-1
              hover:bg-green-600
            "
          >
            <i className="fab fa-whatsapp text-xl" />
            {text.contact}
          </button>
        </div>
      </section>
    </div>
  </main>
);
};

export default Service;
